<template>
    <section class="h-100">
		<div class="container h-100">
			<div class="row justify-content-center h-100">
				<div class="col-xxl-4 col-xl-5 col-lg-5 col-md-7 col-sm-9">
					<div class="text-center my-5"></div>
					<div class="card shadow-lg">
						<div class="card-body p-5">
							<h1 class="fs-4 card-title fw-bold mb-5">
								健康檢查管理系統<img src="@/assets/login-icon.png" alt="logo" width="60px" style="float: right"/>
							</h1>
							<a-form ref="loginForm" :model="formState" name="basic" >
								<div class="mb-3">
									<a-form-item name="userName" :rules="[{ required: true, message: '請輸入帳號名稱' }]">
										<label class="mb-2 text-muted" for="userName">帳號</label>
										<a-input id="userName" size="large" v-model:value="formState.userName" autofocus @pressEnter="focusOnPassword"/>
									</a-form-item>
								</div>
								<div class="mb-3">
									<a-form-item name="password" :rules="[{ required: true, message: '請輸入密碼' }]">
										<label class="mb-2 text-muted" for="password">密碼</label>
										<a-input-password ref="password" size="large" id="password" v-model:value="formState.password" @pressEnter="performLogin"/>
									</a-form-item>
									<!-- TODO: [Frankie] 2025: 實作 忘記密碼選項-->
								</div>
								<div class="mb-3">
									<a-form-item name="rememberMe">
										<!-- <a-checkbox v-model:checked="formState.rememberMe">記住登入帳號</a-checkbox> -->
										<a-button type="primary" @click="performLogin" :disabled="isDoingLogin" style="width: 110px; float: right;">
											<template #icon v-if="isDoingLogin">
												<LoadingOutlined />
											</template>
											登&nbsp;入
										</a-button>
									</a-form-item>
									
								</div>
							</a-form>
						</div>
						<!-- TODO: [Frankie] 2025: 實作 建立新帳號 功能-->
						<!-- <div class="card-footer py-3 border-0">
							<div class="text-center">
								<a href="register.html" class="text-primary">建立新帳號</a>
							</div>
						</div> -->
					</div>
					<div class="text-center mt-5 text-muted">
						Copyright &copy; 2025 &mdash; 三原科技股份有限公司
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script setup>
import { LoadingOutlined } from "@ant-design/icons-vue";
import { ref, reactive } from 'vue';
import router from "@/router";

import config from "@/config";
import common from "@/common";

const loginForm = ref();
const password = ref(null);

const isDoingLogin = ref(false);
const formState = reactive({});

const focusOnPassword = () => {
	if (password.value) {
		password.value.focus();
	}
}

const performLogin = () => {
	loginForm.value.validate()
	.then(() => {
		isDoingLogin.value = true;
		common.postRequest(config.issueOtpContextPath, {
			userId: formState.userName,
			credential: formState.password
		}, (response) => {
			// TODO: [Frankie] Save the username into local storage according to rememberMe.
			isDoingLogin.value = false;
			router.push('/home?otp=' + response.data.otp);
		}, () => {
			isDoingLogin.value = false;
		}, 350);
	}).catch(() => { });
}

// TODO: [Frankie] During page initialization. 
//     1. Get RememberMe from Local Storage state and value if any.
//     2. Autofocus should be removed because the input focusing should be determined by username is remembered or not.
</script>
<style scoped>
span {
  display: inline-flex;
  align-items: center;
}
.ant-btn-primary[disabled],.ant-btn-primary[disabled]:hover {
	color: #ffffff !important;
	background-color: rgb(103, 166, 255);
}
</style>
